<template>
    <div class="create-account container">
        <GoToBack />
        <div class="create-account-content">
            <h1 class="v-content-merchant-clientdata" v-contentMerchantClientdata="{ section: 'Form', removeHtml: true }">Ficha de Cliente</h1>
            <h3 class="v-content-merchant-clientdata" v-contentMerchantClientdata="{ section: 'Form', removeHtml: true }">Complete os seus dados</h3>
            <form @submit.prevent="createAccount()">
                <h4 class="v-content-merchant-clientdata" v-contentMerchantClientdata="{ section: 'Form', removeHtml: true }">Dados Pessoais</h4>
                <div class="form-group">
                    <label for="name" class="name v-content-merchant-clientdata" v-contentMerchantClientdata="{ section: 'Form', removeHtml: true }">Nome</label>
                    <input type="text" id="name" name="name" placeholder="" v-model="name"  required>
                </div>
                <div class="form-group">
                    <label for="phone" class="phone v-content-merchant-clientdata" v-contentMerchantClientdata="{ section: 'Form', removeHtml: true }">Dados telemovel</label>
                    <input type="text" id="phone" name="phone" v-model="phone" placeholder="" @keypress="onlyNumbers" required maxlength="9">
                </div>
                <div class="form-group">
                    <label for="birthday" class="birthday v-content-merchant-clientdata" v-contentMerchantClientdata="{ section: 'Form', removeHtml: true }">Data de nascimento</label>
                    <input type="date" id="birthday" name="birthday" placeholder="" v-model="birthday" required>
                </div>
                <div class="form-group">
                    <label for="gender" class="gender v-content-merchant-clientdata" v-contentMerchantClientdata="{ section: 'Form', removeHtml: true }">Gênero</label>
                    <select id="gender" name="gender" v-model="gender" required>
                        <option value="" class="v-content-merchant-clientdata" v-contentMerchantClientdata="{ section: 'Form', removeHtml: true }">Selecione</option>
                        <option value="m" class="v-content-merchant-clientdata" v-contentMerchantClientdata="{ section: 'Form', removeHtml: true }">Masculino</option>
                        <option value="f" class="v-content-merchant-clientdata" v-contentMerchantClientdata="{ section: 'Form', removeHtml: true }">Feminino</option>
                        <option value="o" class="v-content-merchant-clientdata" v-contentMerchantClientdata="{ section: 'Form', removeHtml: true }">Outro</option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="postalcode" class="postalcode v-content-merchant-clientdata" v-contentMerchantClientdata="{ section: 'Form', removeHtml: true }">Código postal</label>
                    <input type="text" id="postalcode" name="postalcode" v-model="postalcode" placeholder="" @keypress="onlyNumbers" required maxlength="7">
                </div>
                <h4>Dados Faturação</h4>
                <div class="form-group">
                    <label for="namef" class="namef v-content-merchant-clientdata" v-contentMerchantClientdata="{ section: 'Form', removeHtml: true }">Nome faturacão</label>
                    <input type="text" id="namef" name="namef" placeholder="" v-model="namef">
                </div>
                <div class="form-group">
                    <label for="NIF" class="NIF v-content-merchant-clientdata" v-contentMerchantClientdata="{ section: 'Form', removeHtml: true }">NIF</label>
                    <input type="text" id="NIF" name="NIF" placeholder="" v-model="NIF" @keypress="onlyNumbers" maxlength="9">
                </div>
                <!-- <div class="form-group-clientdata">
                    <div class="col-md-12 p-0 form-group-clientdata--checkbox">
                        <input type="checkbox" id="digital-invoice" name="digital-invoice" placeholder="" v-model="digitalInvoice">
                        <label for="digital-invoice" class="digital-invoice v-content-client-data" v-contentClientData="{ section: 'Account', removeHtml: true }">Ativar fatura digital</label>
                    </div>
                </div> -->
                <h4 class="v-content-merchant-clientdata" v-contentMerchantClientdata="{ section: 'Form', removeHtml: true }">Dados de acesso</h4>
                <div class="form-group">
                    <label for="password" class="password v-content-merchant-clientdata" v-contentMerchantClientdata="{ section: 'Form', removeHtml: true }">Palavra-passe</label>
                    <input type="password" id="password" name="password" v-model="password" placeholder="" required>
                </div>
                <button type="submit" class="v-content-merchant-clientdata" v-contentMerchantClientdata="{ section: 'Form', removeHtml: true }">Criar conta</button>
            </form>
        </div>
    </div>
</template>

<script>
import GoToBack from '@/components/buttons/GoToBack.vue'
import axios from 'axios';
import store from "@/store";
import { mapState } from 'vuex';

const allContents = [];
const lang = localStorage.getItem('locale') || 'es';

export default {
    data() {
        return {
            name: '',
            phone: '',
            birthday: '',
            gender: '',
            postalcode: '',
            namef: '',
            NIF: '',
            password: '',
        }
    },
    components: {
        GoToBack
    },
    computed: {
        ...mapState('App', ['loading']),
    },
    methods: {
        onlyNumbers(event) {
            const charCode = event.which ? event.which : event.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                event.preventDefault();
            }
        },
        async createAccount() {
            store.dispatch('App/loading', true);
            try {
                const response = await axios.post('/api/v1/user/create-account', {
                    name: this.name,
                    phone: this.phone,
                    birthday: this.birthday,
                    gender: this.gender,
                    postalcode: this.postalcode,
                    namef: this.namef,
                    NIF: this.NIF,
                    password: this.password,
                    hash: localStorage.getItem('hash'),
                    lang: lang
                });
                
                store.dispatch('App/loading', false);

                if (response.data.success) {
                    localStorage.setItem('hash', response.data.data.hash);
                    this.$router.push('/');
                    this.$swal.fire({
                        icon: 'success',
                        title: 'Sucesso',
                        text: response.data.message,
                        timer: 5000,
                    });
                    this.$router.push('/');
                } else {
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Erro',
                        text: response.data.error.message,
                        timer: 5000,
                    });
                }
            } catch (error) {
                console.error(error);
                store.dispatch('App/loading', false);
                this.$swal.fire({
                    icon: 'error',
                    title: 'Erro',
                    text: error,
                    timer: 5000,
                });
            }
        },
        cleanForm() {
            this.name = '';
            this.phone = '';
            this.birthday = '';
            this.gender = '';
            this.postalcode = '';
            this.namef = '';
            this.NIF = '';
            this.password = '';
        },
        updateDirectives() {
            const allElements = document.querySelectorAll('.v-content-merchant-clientdata');
            allContents.splice(0, allContents.length); // clear the contents array
            allElements.forEach((el) => {
                const params = el.dataset.params ? JSON.parse(el.dataset.params) : {};
                params.content = el.innerHTML.trim();
                if (!('type' in params)) params.type = 'text';
                params.theme = process.env.VUE_APP_THEME;
                params.url_full = `${document.location.protocol}//${document.location.hostname}${document.location.pathname}`;
                allContents.push(params);
            });
        },
    },
    created() {
        this.updateDirectives();
    },
    directives: {
        contentMerchantClientdata: {
            inserted: async function (el, binding) {
                const allElements = document.querySelectorAll('.v-content-merchant-clientdata');
                let params = binding.value ? binding.value : {};
                params.content = el.innerHTML.trim();
                if (!('type' in params)) params.type = 'text';
                params.theme = process.env.VUE_APP_THEME;
                params.url_full = `${document.location.protocol}//${document.location.hostname}${document.location.pathname}`;
                allContents.push(params);

                if (allElements.length == allContents.length) {
                    store.dispatch('App/loading', true);
                    await axios({
                        method: "POST",
                        url: '/api/v1/site/get-all-contents',
                        data: { allContents, lang }
                    })
                    .then(response => response.data)
                    .then((data) => {
                        const allElements = document.querySelectorAll('.v-content-merchant-clientdata');
                        allContents.forEach((el) => {
                            if (el.type == 'text') {
                                allElements.forEach((el, index) => {
                                    el.innerHTML = data.data[index];
                                });
                            }
                        });
                        store.dispatch('App/loading', false);
                    });
                }
            },
        }
    },
}
</script>

<style lang="scss">
.create-account {
    padding: 150px 15px 200px;

    &-content {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
        gap: 35px;
        @media screen and (max-width: 768px) {
            height: auto;
            gap: 50px;
        }

        h1 {
            font-size: 35px;
            font-family: 'Font Bold';
            color: #E84E0F;
            text-align: left;
        }

        h3 {
            font-size: 25px;
            color: #000;
            font-family: 'Font Regular';
            text-align: left;
        }

        form {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            gap: 30px;
            width: 100%;
            @media screen and (max-width: 768px) {
                gap: 50px;
                align-items: center;
            }
            h4{
                font-size: 25px;
                font-family: 'Font Regular';
                color: #E84E0F;
                text-align: left;
                margin-bottom: 20px;    
            }
            .form-group-clientdata {
                display: flex;
                align-items: space-between;
                margin-bottom: 20px;
                width: 100%;
                max-width: 100%;
                gap: 25px;
                @media screen and (max-width: 992px) {
                    flex-direction: column;
                    align-items: flex-start;
                    width: 100%;
                }
                > div {
                    @media screen and (max-width: 992px) {
                        flex: none;
                        width: 100%;
                        max-width: 100%;
                    }
                }

                label {
                    font-size: 18px;
                    line-height: 18px;
                    font-family: 'Font Regular';
                    color: #5E6278;
                    margin-bottom: 20px;
                    text-align: left;
                    width: 100%;
                    @media screen and (max-width: 768px) {
                        margin-right: 0;
                    }
                }

                input[type="text"] {
                    height: 46px;
                    width: 100%;
                    padding: 0 25px;
                    border: none;
                    background: #F1F1F2;
                    color: #7E8299;
                    border-radius: 25px;
                    font-size: 16px;
                    outline: none;
                    &:focus {
                        border-color: #000;
                    }
                    @media screen and (max-width: 992px) {
                        flex: none;
                        width: 100%;
                    }
                }

                input[type="checkbox"] {
                    appearance: none;
                    width: 40px;
                    height: 40px;
                    background: #F1F1F2;
                    color: #7E8299;
                    border-radius: 10px;
                    position: relative;
                    margin-right: 20px;
                    outline: none;
                    cursor: pointer;
                    &:checked {
                        background-color: none;
                        &::after {
                            content: '✔';
                            color: #85D160;
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            font-size: 20px;
                        }
                    }
                }
                
                .form-group-clientdata--checkbox {
                    display: flex;
                    align-items: center;
                    .checkbox-container {
                        display: flex;
                        align-items: center;
                        height: 40px;
                        width: 40px;
                    }
                    label{
                        margin-bottom: 0;
                    }
                }

                input[type="date"] {
                    height: 46px;
                    width: 100%;
                    flex: 1;
                    padding: 0 25px;
                    border: none;
                    background: #F1F1F2;
                    color: #7E8299;
                    border-radius: 25px;
                    font-size: 16px;
                    outline: none;
                    @media screen and (max-width: 992px) {
                        flex: none;
                        width: 100%;
                    }
                }
                input[type="phone"] {
                    height: 46px;
                    width: 100%;
                    flex: 1;
                    padding: 0 15px;
                    border: none;
                    background: #F1F1F2;
                    color: #7E8299;
                    border-radius: 25px;
                    font-size: 16px;
                    outline: none;
                    @media screen and (max-width: 992px) {
                        flex: none;
                        width: 100%;
                    }
                }
                input[type="password"] {
                    height: 46px;
                    width: 100%;
                    flex: 1;
                    padding: 0 15px;
                    border: none;
                    background: #F1F1F2;
                    color: #7E8299;
                    border-radius: 25px;
                    font-size: 16px;
                    outline: none;
                    &:focus {
                        border-color: #000;
                    }
                    @media screen and (max-width: 992px) {
                        flex: none;
                        width: 100%;
                    }
                }

                select{
                    height: 46px;
                    width: 100%;
                    flex: 1;
                    padding: 0 25px;
                    border: none;
                    background: #F1F1F2;
                    color: #7E8299;
                    border-radius: 25px;
                    font-size: 16px;
                    outline: none;
                    appearance: none;
                    background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="14.224" height="8.128" viewBox="0 0 14.224 8.128"><path d="M7.117,8.128A1.016,1.016,0,0,1,6.4,7.833L.3,1.738A1.016,1.016,0,1,1,1.733.3L7.117,5.68,12.491.3a1.016,1.016,0,1,1,1.432,1.443l-6.1,6.1a1.016,1.016,0,0,1-.711.295Z" fill="%237e8299"/></svg>');
                    background-repeat: no-repeat;
                    background-position: right .7em top 50%, 0 0;
                    &:focus {
                        border-color: #000;
                    }
                    @media screen and (max-width: 992px) {
                        flex: none;
                        width: 100%;
                    }
                }
                &-buttons{
                    width: 100%;
                    gap: 20px;
                    @media screen and (max-width: 992px) {
                        flex-direction: column;
                        align-items: center;
                        justify-content: center!important;
                        gap: 20px;
                        width: 100%;
                    }
                }
            }

            .form-group {
                display: flex;
                align-items: center;
                margin-bottom: 20px;
                @media screen and (max-width: 768px) {
                    flex-direction: column;
                    align-items: flex-start;
                    width: 100%;
                }

                label {
                    font-size: 16px;
                    font-family: 'Font Medium';
                    margin-bottom: 5px;
                    text-align: left;
                    max-width: 80%;
                    width: 300px;
                    @media screen and (max-width: 768px) {
                        margin-right: 0;
                    }
                }

                input[type="text"] {
                    height: 50px;
                    width: 398px;
                    flex: 1;
                    padding: 0 15px;
                    border: 2px solid #AEAEAE;
                    border-radius: 10px;
                    font-size: 16px;
                    &:focus {
                        border-color: #000;
                    }
                    @media screen and (max-width: 768px) {
                        flex: none;
                        width: 100%;
                    }
                }

                input[type="checkbox"] {
                    appearance: none;
                    width: 40px;
                    height: 40px;
                    border: 1px solid #787878;
                    border-radius: 7px;
                    position: relative;
                    margin-right: 20px;
                    cursor: pointer;
                    &:checked {
                        background-color: none;
                        &::after {
                            content: '✔';
                            color: #85D160;
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            font-size: 40px;
                        }
                    }
                }
                
                .form-group--checkbox {
                    display: flex;
                    align-items: flex-start;
                    .checkbox-container {
                        display: flex;
                        align-items: center;
                        height: 40px;
                        width: 40px;
                    }
                }

                input[type="date"] {
                    height: 50px;
                    width: 398px;
                    flex: 1;
                    padding: 0 15px;
                    border: 2px solid #AEAEAE;
                    border-radius: 10px;
                    font-size: 16px;
                    &:focus {
                        border-color: #000;
                    }
                    @media screen and (max-width: 768px) {
                        flex: none;
                        width: 100%;
                    }
                }
                input[type="email"] {
                    height: 50px;
                    width: 398px;
                    flex: 1;
                    padding: 0 15px;
                    border: 2px solid #AEAEAE;
                    border-radius: 10px;
                    font-size: 16px;
                    &:focus {
                        border-color: #000;
                    }
                    @media screen and (max-width: 768px) {
                        flex: none;
                        width: 100%;
                    }
                }
                input[type="password"] {
                    height: 50px;
                    width: 398px;
                    flex: 1;
                    padding: 0 15px;
                    border: 2px solid #AEAEAE;
                    border-radius: 10px;
                    font-size: 16px;
                    &:focus {
                        border-color: #000;
                    }
                    @media screen and (max-width: 768px) {
                        flex: none;
                        width: 100%;
                    }
                }

                select{
                    height: 50px;
                    width: 398px;
                    flex: 1;
                    padding: 0 15px;
                    border: 2px solid #AEAEAE;
                    border-radius: 10px;
                    font-size: 16px;
                    &:focus {
                        border-color: #000;
                    }
                    @media screen and (max-width: 768px) {
                        flex: none;
                        width: 100%;
                    }
                }
            }

            button {
                height: 71px;
                width: 328px;
                max-width: 100%;
                background-color: var(--main-color);
                color: #fff;
                font-size: 25px;
                font-family: 'Font Regular';
                border: none;
                border-radius: 7px;
                cursor: pointer;

                &:hover {
                    background-color: #AEAEAE;
                }
            }
        }
    }
}
</style>
